import ajax from './../ajax';

export function getFeedbacks() {
  return ajax('/feedbacks', {
    method: 'GET'
  });
}



// WEBPACK FOOTER //
// ./src/api/v1/feedback.js